export class SurrReqDtlsModel {
  constructor(
    public key: number = 0 ,
    public createdOn: string = null,
    public isActive: string = null,
    public rejectReason: string = null,
    public reqLtrFile: string = null,
    public requestReason: string = null,
    public requestType: string = null,
    public status: string = null,
    public applicationId: number = 0,
    public applicationNo: string = null,
    public eligibilityStatus: string = null,
    public registrationId: number = 0,
    public scheme: string = null,
    public tenement: string = null,
    public applicationPaymentStatus: string = null,
    public acceptanceStatus: string = null,
    public applicationDrawStatus: string = null,
    public panNumber: string = null,
    public lotteryId: number = 0,
    public lotteryCode: string = null,
    public lotteryName: string = null,
    public schemeCode: string = null,
    public schemeName: string = null,
    public schemeKey: number = 0,
    public categoryCode: string = null,
    public applicantName: string = null,
  ) {}
}
